import {Component, Input, OnInit} from '@angular/core';
import {ViewCell} from 'ng2-smart-table';

@Component({
  selector: 'app-tick-cell',
  template: `
      <label class="switch switch-3d switch-success">
          <input type="checkbox" class="switch-input" name="switch_{{rowData.pk}}" id="switch_{{rowData.pk}}" [checked]="renderValue == '1'" disabled>
          <span class="switch-label"></span>
          <span class="switch-handle"></span>
      </label>
  `,
  styleUrls: ['./tick-cell.component.scss']
})
export class TickCellComponent implements OnInit, ViewCell {

    renderValue: string;

    @Input() value: string | number;
    @Input() rowData: any;

    constructor() { }

    ngOnInit() {
        this.renderValue = this.value.toString();
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/components/smart-table/tick-cell/tick-cell.component.ts